import { render, staticRenderFns } from "./multiMedia.vue?vue&type=template&id=504e8b6b&scoped=true"
import script from "./multiMedia.vue?vue&type=script&lang=js"
export * from "./multiMedia.vue?vue&type=script&lang=js"
import style0 from "./multiMedia.vue?vue&type=style&index=0&id=504e8b6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e8b6b",
  null
  
)

export default component.exports